import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum DocumentTypeIds {
  APPROVAL_RECORD = 1,
  AUDIT_REPORT = 2,
  COMPLETION_FORM = 3,
  CSR = 4,
  EMAIL = 5,
  INVOICE = 6,
  IP_JUSTIFICATION = 7,
  LOA = 8,
  ORDER_INFO = 9,
  QUOTE = 10,
  RESPORG = 11,
  ROE = 12,
  SALES_INFO = 13,
  SERVICE_RECORD = 14,
  SOLUTION_DESIGN = 15,
  TRANSFER_OF_OWNERSHIP = 16,
  IMAGE = 17,
  ESCALATION_LIST = 18,
  OTHER = 19,
  CONTRACT = 20,
}

export function getDocumentTypes(): ISelectItem[] {
  return [
    { id: DocumentTypeIds.APPROVAL_RECORD, label: 'Approval Record' },
    { id: DocumentTypeIds.AUDIT_REPORT, label: 'Audit Report' },
    { id: DocumentTypeIds.COMPLETION_FORM, label: 'Completion Form' },
    { id: DocumentTypeIds.CSR, label: 'CSR' },
    { id: DocumentTypeIds.EMAIL, label: 'Email' },
    { id: DocumentTypeIds.INVOICE, label: 'Invoice' },
    { id: DocumentTypeIds.IP_JUSTIFICATION, label: 'IP Justification' },
    { id: DocumentTypeIds.LOA, label: 'LOA' },
    { id: DocumentTypeIds.ORDER_INFO, label: 'Order Info' },
    { id: DocumentTypeIds.QUOTE, label: 'Quote' },
    { id: DocumentTypeIds.RESPORG, label: 'RespOrg' },
    { id: DocumentTypeIds.ROE, label: 'ROE' },
    { id: DocumentTypeIds.SALES_INFO, label: 'Sales Info' },
    { id: DocumentTypeIds.SERVICE_RECORD, label: 'Service Record' },
    { id: DocumentTypeIds.SOLUTION_DESIGN, label: 'Solution Design' },
    {
      id: DocumentTypeIds.TRANSFER_OF_OWNERSHIP,
      label: 'Transfer of Ownership',
    },
    { id: DocumentTypeIds.IMAGE, label: 'Image' },
    { id: DocumentTypeIds.ESCALATION_LIST, label: 'Escalation List' },
    { id: DocumentTypeIds.OTHER, label: 'Other' },
    { id: DocumentTypeIds.CONTRACT, label: 'Contract' },
  ].sort((a, b) => (a.label > b.label ? 1 : -1))
}
export const getDocumentTypeByLabel = getItemByLabelFactory(getDocumentTypes)
export const getDocumentTypeById = getItemByIdFactory(getDocumentTypes)
